// extracted by mini-css-extract-plugin
export default {"root":"_1fY1Nkju","hasIcon":"_1LQpTcIp","icon":"_1aNSqMwM","content":"_1Yo4K1MC","subTitle":"_1cJpUtiC"};